import axios from "axios";
import { AuthenticationService, getToken } from "./auth.service";
import { decodeJwtPayload } from "../util/jwt";
import TranslationService from "../translations/translation.service";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL_BACKEND || process.env.ENTER_BACKEND_URL || 'http://localhost:3001'
});

api.interceptors.request.use(async config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const language = TranslationService.getCurrentLanguage();
  if (language) {
    config.headers["Accept-Language"] = language;
  }
  return config;
});

const isTokenExpired = (token: string | null) => {
  const exp = decodeJwtPayload(token || "")?.exp;
  return typeof exp === "number" && exp * 1000 <= Date.now();
};

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url: string = error?.config?.url || "";
    const isAuthRoute = url.includes("/auth/");
    const onLoginPage = globalThis.location?.pathname === "/login";

    if (status === 401 && !isAuthRoute && !onLoginPage && isTokenExpired(getToken())) {
      AuthenticationService.clearSession();
      globalThis.location.href = `/login?redirectTo=${encodeURIComponent(
        globalThis.location.pathname + globalThis.location.search
      )}`;
    }
    return Promise.reject(error);
  }
);

export default api;
